import * as Fiz from "../util/Fiz.ts";
import ApiServer from "./fizapilib.auto.ts";

Object.assign(ApiServer.types.PremiumRightBean.prototype,{
  isPremium(){
    return this.fWPremiumPopup === true;
  }

});

Object.assign(ApiServer.types.ServerBeanPrototype.prototype,{
  thumbDefault(){
    return Fiz.getDefaultUrl(this.firstName||this.firstname||this.accountFirstname||'',this.color||"#c9c9c9");
  },
  thumbNoDefault(){
    if(this.pictureDefault) return undefined;
    return this.thumb();
  },
  thumb(size=120){
    if(this.coverUri){
      return Fiz.getPictureUrl(this.coverUri,size,size);
    }else if(this.pictureDefault){
      return this.thumbDefault()
    }else if(this.picture){
      return Fiz.getPictureUrl(this.picture,size,size);
    }else if(this.pictureUrl){
      return Fiz.getPictureUrl(this.pictureUrl,size,size);
    }else if(this.medias && this.medias.length){
      return Fiz.getPictureUrl(this.medias[0].pictureUrl,size,size);
    }else if(this.accountMedias && this.accountMedias.length){
      //im participant
      return Fiz.getPictureUrl(this.accountMedias[0].pictureUrl,size,size);
    }else{
      return undefined;
    }
  },
  lastMediaImage(){
    return this.medias?.reduce((prev,next)=>next.isImage()?next:prev,null)
  }
});


Object.assign(ApiServer.types.AccountStateBean.prototype,{
  onDecode(){
    if(this.option && this.option.indexOf('BUNDLED')>-1){
      this.option = 'BUNDLED';
    }else if(this.option && this.option.indexOf('SUBSCRIBED')>-1){
      this.option = 'SUBSCRIBED';
    }else{
      this.option = 'NONE';
    }
  }
});


